import React from "react";
import camelCase from "lodash/camelCase";
import PropTypes from "prop-types";

import SpaceSize from "components/Spaces/components/SpaceSize";
import categoryIcons from "utils/spaces/categoryIcons";

import styles from "./SpaceLabel.css";

const SpaceLabel = ({ isExtended, space, withAsset }) => {
  const { area, asset, capacity, category, leaseholders, name } = space;
  const leaseholder = !!leaseholders && leaseholders.length && leaseholders[0];
  const Icon = categoryIcons[camelCase(category)];

  return (
    <div className={styles.root}>
      <div className={styles.left}>
        {isExtended && (
          <div className={styles.icon}>
            <Icon />
          </div>
        )}
        {withAsset && asset && <div className={styles.asset}>{asset.name}</div>}
        <div className={styles.name}>{name}</div>
        {isExtended && (
          <div className={styles.size}>
            <SpaceSize
              area={area}
              capacity={capacity}
              isUnitBlack={false}
              isValueBold={false}
              spaceCategory={category}
              isSmall
            />
          </div>
        )}
      </div>
      {isExtended && !!leaseholder && (
        <div className={styles.right}>
          <div>{leaseholder.name}</div>
          {leaseholder.expirationDate && <div>{leaseholder.expirationDate}</div>}
          {leaseholders.length > 1 && <small>+{leaseholders.length - 1}</small>}
        </div>
      )}
    </div>
  );
};

SpaceLabel.propTypes = {
  space: PropTypes.shape({
    asset: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }),
    name: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    leaseholders: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        expirationDate: PropTypes.string,
      })
    ),
  }).isRequired,
  isExtended: PropTypes.bool,
  withAsset: PropTypes.bool,
};

export default SpaceLabel;
